var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3528_24652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3528_24652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83268 13.8334L14.7077 7.95841L13.541 6.79175L8.83268 11.5001L6.45768 9.12508L5.29102 10.2917L8.83268 13.8334ZM9.99935 18.3334C8.84657 18.3334 7.76324 18.1145 6.74935 17.6767C5.73546 17.2395 4.85352 16.6459 4.10352 15.8959C3.35352 15.1459 2.7599 14.264 2.32268 13.2501C1.8849 12.2362 1.66602 11.1529 1.66602 10.0001C1.66602 8.8473 1.8849 7.76397 2.32268 6.75008C2.7599 5.73619 3.35352 4.85425 4.10352 4.10425C4.85352 3.35425 5.73546 2.76036 6.74935 2.32258C7.76324 1.88536 8.84657 1.66675 9.99935 1.66675C11.1521 1.66675 12.2355 1.88536 13.2493 2.32258C14.2632 2.76036 15.1452 3.35425 15.8952 4.10425C16.6452 4.85425 17.2388 5.73619 17.676 6.75008C18.1138 7.76397 18.3327 8.8473 18.3327 10.0001C18.3327 11.1529 18.1138 12.2362 17.676 13.2501C17.2388 14.264 16.6452 15.1459 15.8952 15.8959C15.1452 16.6459 14.2632 17.2395 13.2493 17.6767C12.2355 18.1145 11.1521 18.3334 9.99935 18.3334ZM9.99935 16.6667C11.8605 16.6667 13.4368 16.0209 14.7285 14.7292C16.0202 13.4376 16.666 11.8612 16.666 10.0001C16.666 8.13897 16.0202 6.56258 14.7285 5.27091C13.4368 3.97925 11.8605 3.33341 9.99935 3.33341C8.13824 3.33341 6.56185 3.97925 5.27018 5.27091C3.97852 6.56258 3.33268 8.13897 3.33268 10.0001C3.33268 11.8612 3.97852 13.4376 5.27018 14.7292C6.56185 16.0209 8.13824 16.6667 9.99935 16.6667Z",
    fill: "#67748E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.ea8f820c434dc11ab9ee497e890119de.svg";
export { ForwardRef as ReactComponent };